import { IImage } from "@faire/web-api/indigofair/data/IImage";

export interface IImageByViewport {
  mobile: IImage | undefined;
  tablet: IImage | undefined;
  desktop: IImage | undefined;
  xlarge: IImage | undefined;
}

/**
 * Create a mapping of images determined by the type property of the image. Only need to use this function if
 * images are different for each viewport.
 * @param images IImage[]
 * @returns IImageByViewport
 */
export const generateCSSBreakpointMapForImages = (
  images: IImage[]
): IImageByViewport => {
  return images.reduce((acc, image) => {
    if (image.type === IImage.Type.MOBILE) {
      acc.mobile = image;
    }
    if (image.type === IImage.Type.TABLET) {
      acc.tablet = image;
    }
    if (image.type === IImage.Type.DESKTOP) {
      acc.desktop = image;
    }
    if (image.type === IImage.Type.XLARGE_DESKTOP) {
      acc.xlarge = image;
    }
    return acc;
  }, {} as IImageByViewport);
};
